/* eslint-disable react/jsx-curly-brace-presence */
import React from "react";
import { IDownloadableContent } from "../../interfaces";
import { ASSETS_DOWNLOADS } from "../../assets";

const ICON = `${ASSETS_DOWNLOADS}/launcher/icon.png`;
const SCREENSHOTS = `${ASSETS_DOWNLOADS}/launcher/screenshots`;

const launcher: IDownloadableContent = {
  id: 1,
  urls: ["https://ps.fhxrestoration.com/v2/pds/public/FHX.exe"],
  filesizeMb: 22,
  md5Checksum: "536f069bd2fec28e6a732135444b0e7e",
  sha1Checksum: "b15693ebfa681c7f003655a42cb0fc0f09b21875",
  isDownloadDisabled: false,
  i18nName: {
    en: "FHX Restoration Game Launcher",
    de: "FHX Restoration Game Launcher",
    he: "הורדת לאנצ'ר המשחק של FHX Restoration",
  },
  i18nDescription: {
    en: (
      <>
        <p>Latest version of the official FHX Restoration Game Launcher. Required to play the game.</p>
        <p>
          <div>
            <strong>
              <u>System requirements</u>
            </strong>
          </div>
          <p>
            The hardware requirements for the game itself are pretty low ({"it's"} original release was in 2010 and
            before). However, there is one thing that we would like to suggest:
            <ul>
              <li>a 64-bit operating system (preferably Windows 10)</li>
            </ul>
          </p>
        </p>
        <p>
          <div>
            <strong>
              <u>Troubleshooting</u>
            </strong>
          </div>
          <p>
            <ul>
              <li>
                <h4>Windows {"doesn't"} let me install the game (untrusted application)</h4>
                The game is not properly signed yet so Windows {"doesn't"} like it. We will change it in the future.{" "}
                <br />
                When you see the window saying <b>”Windows protected your PC”</b>, just click on <u>”More info”</u> and{" "}
                <u>”Run anyway”</u>.
              </li>
              <li>
                <h4>”The application was unable to start correctly (0xc00000??)”</h4>Try to start it again. Sometimes is
                takes several tries to succeed.
              </li>
            </ul>
          </p>
        </p>
      </>
    ),
    he: (
      <>
        <p>הגרסה האחרונה והרשמית של {"לאנצ'ר"} המשחק של FHX Restoration. נדרש על מנת לשחק במשחק.</p>
        <p>
          <div>
            <strong>
              <u>דרישות מערכת</u>
            </strong>
          </div>
          <p>
            דרישות החומרה למשחק עצמו הן נמוכות למדי (המשחק המקורי שוחרר ב-2010 ואפילו לפני). עם זאת, יש לנו המלצה אחת:
            <ul>
              <li>מערכת הפעלה 64 ביט (עדיפות לווינדוס 10)</li>
            </ul>
          </p>
        </p>
        <p>
          <div>
            <strong>
              <u>פתרון תקלות</u>
            </strong>
          </div>
          <p>
            <ul>
              <li>
                <h4>הווינדוס לא נותן לי להתקין את המשחק (שגיאת ישום לא מוכר)</h4>
                המשחק עדיין לא רשום כמו שצריך אז ווינדוס לא אוהב את זה. אנחנו נשנה את זה בעתיד. <br />
                כאשר אתם רואים את המסך <b>”Windows הגן על המחשב שלך”</b>, פשוט לחצו על <u>”הפעל בכל מקרה”</u>.
              </li>
              <li>
                <h4>”The application was unable to start correctly (0xc00000??)”</h4>נסו להריץ שוב. לפעמים לוקח כמה
                ניסיונות להצליח.
              </li>
            </ul>
          </p>
        </p>
      </>
    ),
  },
  icon: ICON,
  screenshots: [
    `${SCREENSHOTS}/screen1.png`,
    `${SCREENSHOTS}/screen2.png`,
    `${SCREENSHOTS}/screen3.png`,
    `${SCREENSHOTS}/screen4.png`,
  ],
};

export default launcher;
